import { InformerProps } from '@/shared/ui';

export const asideInformer: InformerProps = {
  text: {
    text: 'Вам доступні Витяги про несудимість, сформовані протягом попереднього календарного місяця. Якщо Витяги про несудимість отримано з метою  "Усиновлення, встановлення опіки та піклування, створення прийомної сім`ї або дитячого будинку сімейного типу", то вони доступні за попередній рік.',
    color: 'black',
  },
  header: { text: 'Зверніть увагу!', color: 'blue' },
  icon: { name: 'attention', color: 'blue' },
  borderColor: 'blue',
};
